import { pgTable, uuid, timestamp, index, unique } from 'drizzle-orm/pg-core';
import { users } from './users';
import { tenants } from './tenants';

const schema = {
  id: uuid('id').defaultRandom().primaryKey(),
  tenant_id: uuid('tenant_id').notNull().references(() => tenants.id),
  user_id: uuid('user_id').notNull().references(() => users.id),
  date_created: timestamp('date_created', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
}

/**
 * @ignore
 * @internal
 */
export const tenantUsers = pgTable(
  'TenantUsers',
  schema,
  (table) => [
    index('tenant_user_tenant_id_idx').on(table.tenant_id),
    index('tenant_user_user_id_idx').on(table.user_id),
    index('tenant_user_tenant_user_idx').on(table.tenant_id, table.user_id),
    unique('tenant_users_tenant_user_unique').on(table.tenant_id, table.user_id),
  ]
);
